module.exports = __webpack_public_path__ + "img/man--1920.40d4fa6.jpg";